export default __webpack_public_path__ + "static/media/PoweredByBlue.85d3c7ff.png";